import React from 'react';
import Research from '../components/Research';
import Footer from '../components/Footer';

function ResearchPage() {
  return (
    <div className="page">
      <main>
        <Research />
      </main>
      <Footer />
    </div>
  );
}

export default ResearchPage;
